import * as React from "react";

function IconDeviceTabletOff({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-device-tablet-off" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/device-tablet-off"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M7 3h11a1 1 0 0 1 1 1v11m0 4v1a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-15" /><circle cx={12} cy={17} r={1} /><path d="M3 3l18 18" /></svg>;
}

export default IconDeviceTabletOff;